import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class ElectionService {
    constructor() {
        this.httpCleint = new HttpClient()
    }

    getElectionList(fundID, page, size) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `funds/${fundID}/elections`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewElection(
        fundID,
        groupId,
        title,
        startDate,
        startTime,
        endDate,
        endTime,
        published,
        enabled,
        candidatesList,
        description
    ) {
        return new Promise((resolve, reject) => {
            const candidates = []
            candidatesList.map(item => {
                candidates.push({
                    "title": item.label
                })

            })
            this.httpCleint.post(
                `funds/${fundID}/groups/${groupId}/elections`,
                {
                    "title": title,
                    "description": description,
                    "startPersianTime": startTime + ":00",
                    "endPersianTime": endTime + ":00",
                    "startPersianDate": startDate.replaceAll("/", "-"),
                    "endPersianDate": endDate.replaceAll("/", "-"),
                    "enabled": enabled,
                    "published": published,
                    "candidates": candidates
                }
            ).then(resolve).catch(reject)
        })
    }

    getElectionBasicInfo(fundID, electionId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `funds/${fundID}/elections/${electionId}`
            ).then(resolve).catch(reject)
        })
    }

    getElectionResult(fundID, electionId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `funds/${fundID}/elections/${electionId}/results`
            ).then(resolve).catch(reject)
        })
    }

    disableElection(fundID, electionId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.delete(
                `funds/${fundID}/elections/${electionId}`
            ).then(resolve).catch(reject)
        })
    }

    endElection(fundID, electionId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.put(
                `funds/${fundID}/elections/${electionId}/force-finish`
            ).then(resolve).catch(reject)
        })
    }

    getElectionVotes(fundID, electionId, candidateId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `funds/${fundID}/elections/${electionId}/candidates/${candidateId}/votes`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    updateElectionEndTimeDate(fundID, groupId, electionId, title, startDate, startTime, endDate, endTime, publish, candidatesList, description) {

        const candidates = []
        candidatesList.map(item => {
            candidates.push({
                "title": item.label
            })

        })


        return new Promise((resolve, reject) => {
            this.httpCleint.put(
                `funds/${fundID}/groups/${groupId}/elections/${electionId}`,
                {
                    "title": title,
                    "description": description,
                    "startPersianTime": startTime.length === 8 ? startTime : startTime + ":00",
                    "endPersianTime": endTime.length === 8 ? endTime : endTime + ":00",
                    "startPersianDate": startDate.replaceAll("/", "-"),
                    "endPersianDate": endDate.replaceAll("/", "-"),
                    "enabled": true,
                    "published": publish,
                    "candidates": candidates
                }
            ).then(resolve).catch(reject)
        })
    }
}